import { Analytics } from './components/Analytics';
import { AutoReload } from './components/AutoReload';
import { DatePicker } from './components/DatePicker';
import { Validation } from './components/Validation';
import { MemberArea } from './components/MemberArea';
import { Tabs } from './components/Tabs';
import { Modals } from './components/Modals';
import { CookiesConsent } from '../twig/components/CookiesConsent';
import { Accordion } from '../twig/components/Accordion';
import { Carousel } from './components/Carousel';
import { Collapse } from './components/Collapse';
import { Header } from '../twig/components/Header';
import { Notification } from '../twig/components/Notification';
import { Footer } from '../twig/components/Footer';
import { FileUploaders } from '../twig/components/FileUploader';
import { FileMakerLists } from '../twig/components/FileMakerList';
import { FileMakerSearch } from '../twig/components/FileMakerSearch';
import { Menu } from '../twig/components/Menu';
import { Video } from '../twig/components/Video';
import { Navigator } from './components/Navigator';
import { EventCarousel } from '../twig/modules/events_carousel';
import { ModuleBoxes } from '../twig/modules/boxes';
import { Form } from '../twig/modules/form';
import { SingleShow } from '../twig/pages/single-show/';
import { Requests } from '../twig/pages/client-requests/';
import { Request } from '../twig/pages/client-request/';
import { ClientDetailsTheater } from '../twig/pages/client-details-theater/';
import { ToolTransferPrice } from '../twig/tools/TransferPrice/';
import { ClientShow } from '../twig/pages/client-show';
import { LanguageSelector } from '../twig/components/LanguageSelector';
import { DataApiDebug } from './components/DataApiDebug';
import { AsyncLoad } from './components/AsyncLoad';
import { DirectoryPlace } from '../twig/pages/directory-place';
(new Analytics()).init();
(new DatePicker()).init();
(new AutoReload()).init();
(new Accordion()).init();
(new Carousel()).init();
(new Collapse()).init();
(new Notification()).init();
(new Header()).init();
(new Footer()).init();
(new FileMakerLists()).init();
(new FileMakerSearch()).init();
(new Menu()).init();
(new Video()).init();
(new Tabs()).init();
(new ModuleBoxes()).init();
(new Form()).init();
(new SingleShow()).init();
(new ToolTransferPrice()).init();
(new Modals()).init();
(new MemberArea()).init();
(new FileUploaders()).init();
(new Requests()).init();
(new Request()).init();
(new Navigator()).init();
(new EventCarousel()).init();
(new LanguageSelector()).init();
(new DataApiDebug()).init();
(new AsyncLoad()).init();
(new ClientDetailsTheater()).init();
(new DirectoryPlace()).init();
// Always at the end
(new Validation()).init();
(new CookiesConsent()).init();
(new ClientShow()).init();
